import React from 'react';
import {
    FileProtectOutlined,
    TeamOutlined,
    DashboardOutlined,
    VideoCameraOutlined, SettingOutlined, CarOutlined, GroupOutlined, InsertRowAboveOutlined, CustomerServiceOutlined
} from '@ant-design/icons';
import {Menu} from "antd";
import {Link, useLocation} from "react-router-dom";

const {SubMenu} = Menu;

const routeList = [
    {
        id: "1",
        label: "Yönetici Ekranı",
        icon: <DashboardOutlined style={{fontSize: '130%'}}/>,
        path: "/reports/manager-report"
    },
    {
        id: "2",
        label: "Harita İzleme",
        icon: <VideoCameraOutlined style={{fontSize: '130%'}}/>,
        path: "/"
    },
    {
        id: "3",
        label: "Can Bus Dashboard",
        icon: <InsertRowAboveOutlined style={{fontSize: '130%'}}/>,
        path: "/canbus-dashboard"
    },
    {
        id: "4",
        label: "Liste İzleme",
        icon: <CarOutlined style={{fontSize: '130%'}}/>,
        path: "/live"
    },
    {
        id: '5',
        label: 'Raporlar',
        icon: <FileProtectOutlined style={{fontSize: '130%'}}/>,
        path: '/reports',
        subMenu: [
            {
                id: '5-1',
                label: 'Canbus Özet Raporu',
                icon: <FileProtectOutlined style={{fontSize: '130%'}}/>,
                path: '/reports/canbus-summary',
            },
            {
                id: '5-2',
                label: 'Canbus Raporu',
                icon: <FileProtectOutlined style={{fontSize: '130%'}}/>,
                path: '/reports/canbus',
            },
            {
                id: '5-3',
                label: 'Yakıt Tüketim Raporu',
                icon: <FileProtectOutlined style={{fontSize: '130%'}}/>,
                path: '/reports/idle-fuel',
            },
            {
                id: '5-4',
                label: 'Alarm Raporu',
                icon: <FileProtectOutlined style={{fontSize: '130%'}}/>,
                path: '/reports/alarm',
            },
            {
                id: '6-4',
                label: 'Kontak/Mesafe Raporu',
                icon: <FileProtectOutlined style={{fontSize: '130%'}}/>,
                path: '/reports/contact',
            },
        ],
    },
    {
        id: '6',
        label: 'Ayarlar',
        icon: <SettingOutlined style={{fontSize: '130%'}}/>,
        path: '/settings',
        subMenu: [
            {
                id: '6-1',
                label: 'Genel Ayarlar',
                icon: <SettingOutlined style={{fontSize: '130%'}}/>,
                path: '/settings',
            },
            {
                id: '6-2',
                label: 'Araçlar',
                icon: <DashboardOutlined style={{fontSize: '130%'}}/>,
                path: '/settings/vehicles',
            },
            {
                id: '6-3',
                label: 'Sürücüler',
                icon: <TeamOutlined style={{fontSize: '130%'}}/>,
                path: '/settings/drivers',
            },
            {
                id: '6-4',
                label: 'Grup Tanımlama / Ekleme',
                icon: <GroupOutlined style={{fontSize: '130%'}}/>,
                path: '/settings/groups',
            },
        ],
    },
    {
        id: "7",
        label: "Destek",
        icon: <CustomerServiceOutlined style={{fontSize: '130%'}}/>,
        path: "/support"
    },
]

const RouteList = () => {
    const location = useLocation();
    const activePath = location.pathname.split('/')[1];

    return (
        <Menu
            theme="dark"
            mode="horizontal"
            defaultSelectedKeys={['/']}
            selectedKeys={[
                activePath === 'vehicles' ||
                activePath === 'drivers' ||
                activePath === 'live' ||
                activePath === 'lines'
                    ? '/' + activePath
                    : location.pathname,
            ]}
            style={{width: '100%'}}
        >
            {routeList.map((route) => {
                if (route.subMenu) {
                    return (
                        <SubMenu key={route.path} icon={route.icon} title={route.label}>
                            {route.subMenu.map((subItem) => (
                                <Menu.Item key={subItem.path} icon={subItem.icon}>
                                    <Link to={subItem.path}>{subItem.label}</Link>
                                </Menu.Item>
                            ))}
                        </SubMenu>
                    );
                } else {
                    return (
                        <Menu.Item key={route.path} icon={route.icon}>
                            <Link to={route.path}>{route.label}</Link>
                        </Menu.Item>
                    );
                }
            })}
        </Menu>
    );
};

export default RouteList;
